<template>
  <div class="fff">
    <div class="page_title">{{ $t("shoppingCart.txt1") }}</div>
    <div class="page_bo_li">
      <div class="ShoppingCart_t_l">
        <img v-if="system == 1" src="@/assets/img/a.png" />
        <img v-else src="@/assets/img/i.png" />
        <div>
          {{ system == 1 ? $t("shoppingCart.txt2") : $t("shoppingCart.txt3")
          }}<br />{{ name }}
        </div>
      </div>
      <div class="ShoppingCart_t_r">
        <el-select @change="getli()" class="input" v-model="id" placeholder="">
          <el-option
            v-for="item in packagePrices"
            :key="item.id"
            :label="
              item.length +
              '-' +
              $t('Month Plan') +
              ' ($' +
              item.price +
              '/' +
              $t('shoppingCart.txt6') +
              ')'
            "
            :value="item.id"
          >
          </el-option>
        </el-select>
        <!-- <div class="input">3-Month Plan ($99/Month) <img src="@/assets/img/dow.png" alt="">
      </div>-->
        <div class="firstChild">
          {{ $t("shoppingCart.txt4") }}
          <span
            >${{ price }} <s>${{ oldprice }}</s></span
          >
        </div>
        <div class="firstChild">
          {{ $t("shoppingCart.txt5")
          }}<span>{{ Month }} {{ $t("shoppingCart.txt6") }}</span>
        </div>
      </div>
    </div>
    <div class="page_bo_li" style="padding-bottom: 30px" v-if="isshow">
      <div class="sc_input">
        <div>{{ $t("shoppingCart.txt7") }}</div>
        <input :placeholder="$t('Card Number')" />
      </div>
      <div class="sc_input fl">
        <div>{{ $t("shoppingCart.txt8") }}</div>
        <input :placeholder="$t('MM')" class="w_50 mr2" />
        <input :placeholder="$t('YY')" class="w_50" />
      </div>
      <div class="sc_input fl">
        <div>{{ $t("shoppingCart.txt9") }}</div>
        <input :placeholder="$t('CVV')" class="w_50" />
      </div>
      <div class="sc_input">
        <div>{{ $t("shoppingCart.txt10") }}</div>
        <input :placeholder="$t('First name')" class="w_50 mr2" />
        <input :placeholder="$t('Last name')" class="w_50" />
      </div>
      <div class="sc_input">
        <div>{{ $t("shoppingCart.txt11") }}</div>
        <input :placeholder="$t('Email')" />
      </div>
    </div>
    <div @click="goorder" class="loginButton ShoppingCartButton">
      {{ $t("shoppingCart.txt12") }}
    </div>
    <paddler ref="paddler" @paySuccess="paySuccess" />
  </div>
</template>

<script>
import { createVipOrder } from "@/api/user";
import paddler from "./paddler/paddler";

export default {
  name: "HelloWorld",
  components: {
    paddler,
  },
  data() {
    return {
      system: this.$route.params.system,
      packagePrices: this.$route.params.package_prices,
      id: this.$route.params.id,
      name: this.$route.params.name,
      Month: "",
      price: "",
      oldprice: "",
      isshow: false,
      msg: "",
    };
  },
  mounted() {
    this.getli();
  },
  methods: {
    paySuccess() {
      // this.$notify({
      //   title: '支付成功',
      //   message: '你已成功支付,即将跳转到绑定设备页面,走绑定流程',
      //   type: 'success'
      // })
      this.$router.push({ name: "Guidance" });
    },
    getli() {
      for (var a = 0; a < this.packagePrices.length; a++) {
        if (this.id === this.packagePrices[a].id) {
          this.Month = this.packagePrices[a].length;
          this.price = this.packagePrices[a].price;
          this.oldprice = this.packagePrices[a].del_price;
        }
      }
    },
    goorder() {
      let key = {
        name: this.name,
        order_price: this.oldprice,
        pay_price: this.price,
        package_price_id: this.id,
        type: this.system === 1 ? 1 : 2,
      };
      createVipOrder(key).then(({ data }) => {
        this.$refs.paddler.showEdit(data.id);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  background: #fff;
  overflow: hidden;
}
.ShoppingCart_t_l {
  float: left;
  width: 45%;
  overflow: hidden;
  height: 180px;
}
.ShoppingCart_t_l img {
  float: left;
  width: 120px;
  overflow: hidden;
  margin: 30px 0 0;
}
.ShoppingCart_t_l div {
  float: left;
  overflow: hidden;
  margin: 60px 0 0 20px;
  line-height: 30px;
  font-size: 16px;
  color: #000927;
  font-weight: 700;
}
.ShoppingCart_t_r {
  float: left;
  width: 55%;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkI4MjY3MTY2RUM0QjExRUJCMURBRjY2RUE2NDY1NzU4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkI4MjY3MTY3RUM0QjExRUJCMURBRjY2RUE2NDY1NzU4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QjgyNjcxNjRFQzRCMTFFQkIxREFGNjZFQTY0NjU3NTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QjgyNjcxNjVFQzRCMTFFQkIxREFGNjZFQTY0NjU3NTgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5HVGmWAAAAD0lEQVR42mJ4+PgZQIABAAVTAqu9pHiVAAAAAElFTkSuQmCC)
    0 repeat-y;
  height: 180px;
}
.ShoppingCart_t_r div {
  width: 75%;
  margin: 0 12.5%;
}
.ShoppingCart_t_r div.input {
  background: #f6f8fa;
  border: 1px solid #d5d7db;
  border-radius: 20px;
  margin-top: 30px;
  height: 40px;
  line-height: 40px;
  font-size: 13px;
  text-indent: 10px;
}
.ShoppingCart_t_r div.input img {
  float: right;
  width: 16px;
  margin: 12px;
}
.ShoppingCart_t_r div.firstChild {
  width: 70%;
  font-size: 13px;
  color: #000927;
  margin-top: 20px;
  height: 20px;
  line-height: 20px;
}
.ShoppingCart_t_r div.firstChild span {
  float: right;
  color: #01dbb3;
  font-weight: 700;
}
.ShoppingCart_t_r div.firstChild span s {
  font-size: 13px;
  color: grey;
  font-weight: 400;
  margin-left: 5px;
}
.sc_input {
  width: 35%;
  margin-left: 4%;
  padding-top: 20px;
  overflow: hidden;
}
.sc_input.fl {
  float: left;
}
.sc_input div {
  font-size: 12px;
  color: #45484d;
  font-weight: 400;
  line-height: 30px;
  height: 30px;
}
.sc_input input {
  width: 98%;
  padding: 0;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  background: #f6f8fa;
  height: 36px;
  line-height: 36px;
  font-size: 13px;
  text-indent: 5px;
  float: left;
}
.sc_input input.w_50 {
  width: 48%;
}
.sc_input input.w_50.mr2 {
  margin-right: 2%;
}
.ShoppingCartButton {
  float: left;
  margin-left: 5%;
  width: 280px;
  height: 44px;
  line-height: 44px;
  font-size: 15px;
}
</style>
<style>
.ShoppingCart_t_r .el-input--suffix .el-input__inner {
  background: none;
}
/* .ShoppingCart_t_r .el-select .el-input__inner:focus{border: none;} */
.ShoppingCart_t_r .el-input__inner {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ShoppingCart.vue